import Jinghailu from '@/micro-app/jinghailu';
import { useSlideMenuCollapse } from '@/hooks/useSlideMenuCollapsedChange';
// import { useTopGlobalNavCollapse } from '@/hooks/useTopGlobalNavCollapsedChange';

export default function Interaction() {
  useSlideMenuCollapse({ delay: 1000 });
  // useTopGlobalNavCollapse({ delay: 1000 });
  return <Jinghailu />;
}
